import api from './api';

export const saveLead = async (rideId: string) => {
  const response = await api.post(`/api/driver/rides/${rideId}/save`);
  return response.data;
};

export const unsaveLead = async (rideId: string) => {
  const response = await api.post(`/api/driver/rides/${rideId}/unsave`);
  return response.data;
};

export const hideLead = async (rideId: string, reason?: string) => {
  const response = await api.post(`/api/driver/rides/${rideId}/hide`, { reason });
  return response.data;
};

export const unhideLead = async (rideId: string) => {
  const response = await api.post(`/api/driver/rides/${rideId}/unhide`);
  return response.data;
};

export const reportLead = async (
  rideId: string,
  type: 'not_relevant' | 'invalid_contact' = 'not_relevant',
  reason?: string
) => {
  const response = await api.post(`/api/driver/rides/${rideId}/report`, { type, reason });
  return response.data;
};
